import React from 'react'
// hooks
import { useHasConnectedIntegrations } from './hooks/useHasConnectedIntegrations'
// components
import IntegrationCard, { IntegrationsProps } from './components/IntegrationCard'
// views
import { Title, Wrapper } from './views'

const IntegrationsSection: React.FC<IntegrationsProps> = ({ integrations }) => {
  const hasConnectedIntegrations = useHasConnectedIntegrations()

  if (!hasConnectedIntegrations) {
    return null
  }

  return (
    <Wrapper>
      <Title>Integrations</Title>
      <IntegrationCard integrations={integrations} />
    </Wrapper>
  )
}

export default IntegrationsSection
